(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('ManageExaminersDialogController', ManageExaminersDialogController);

    function ManageExaminersDialogController(logger, $uibModalInstance, $translate, examiners) {
        var vm = this;

        vm.examiners = angular.copy(examiners);
        
        vm.cancel = cancel;
        vm.deleteExaminer = deleteExaminer;
        vm.identitySelected = identitySelected;
        vm.ok = ok;
        
        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function deleteExaminer(idx) {
            vm.examiners.splice(idx, 1);
        }

        function identitySelected(identity) {
            var existing = _.find(vm.examiners, { idString: identity.idString });
            if (existing) return;
            vm.examiners.push({ idString: identity.idString, name: identity.displayName });
        }

        function ok() {
            $uibModalInstance.close(vm.examiners);
        }
        
    }
})();
